export const ORIGIN_LIST_TYPE = 'origin'
export const TEMPLATE_LIST_TYPE = 'template'
export const SPORT_GROUP_LIST_TYPE = 'sport-group'
export const STORE_GROUP_LIST_TYPE = 'store-group'
export const DND_INDEX_SUBITEM_COEF = 10000
